const MODAL_SLUG_KEYS = {
    about: 'about_us',
    privacy: 'privacy_policy',
    terms: 'terms',
};

/**
 * @param {object} modals_slug - `about_us` / `privacy_policy` / `terms` from buildEnv.
 * @param {'about'|'privacy'|'terms'} type
 * @returns {string|undefined}
 */
export function getGamblingModalSlug(modals_slug, type) {
    const key = MODAL_SLUG_KEYS[type];

    return key ? modals_slug[key] : undefined;
}
